<template>
  <div>
    <div class="view-main">
      <button @click="$router.push({ name: 'Home' })" class="voltar-btn">voltar</button>
      <i style="position:relative; right: 100px; font-size: 35px;" :class="iconClass"></i>
      <p style="position:relative; right: 100px;">{{titulo}}</p> 
    </div>
    <div style="height:0;display:flex;align-items:center;justify-content:center;">
      
      <div class="bordert"></div>
    </div>
    <div v-if="tipo == 'Links'">
      <div  style="margin: 250px 0" class="flex-centered" v-if="spinner == true">
        <b-spinner>

        </b-spinner>
      </div>
      <div v-for="(item,i) in resultado" :key="i" style="margin-top: 35px; margin-bottom: 10px; flex-direction: column; font-weight: lighter;" class="view-main">
      <p>{{ item.categoria }}</p>
      <div v-for="(link,j) in item.links" :key="j">
      <a :href="link._Link" target="_blank"><p style="margin-top: 10px;font-size: 20px; font-style:normal;">{{ link.titulo }}</p></a>
      </div>
    </div>
    </div>
    <div v-else>
    <p v-if="tipo == 'Matéria' || tipo == 'Legislação' || tipo == 'Vídeo' || tipo == 'Plantão'"
      style="font-size:20px; margin-left: 150px; margin-top: 50px; font-style: italic; color:#383838; font-weight: 500;"
    >Filtro de Busca</p>
    <div v-if="tipo == 'Matéria' || tipo == 'Legislação' || tipo == 'Vídeo' || tipo == 'Plantão'"  class="viewinputs">
      <p class="textinputs">Descrição</p>
      <input v-model="descricao" placeholder="Descreva o que procura" type="text" />
      <p style="margin-left:20px" class="textinputs">Estado</p>
      <select
        :key="i"
        v-model="estado"
        placeholder="Selecione o estado"
        style="width:178px"
        type="text"
      >
        <option value="0">Selecione o estado</option>
        <option v-for="item in estados" :key="item" :value="item.id">{{ item.estado }}</option>
      </select>
      <button @click="buscar()" class="buscar-btn">
        <i style="position:relative; left: -7px;" class="fas fa-search"></i>buscar
      </button>
    </div>
    <div class="viewcontent">
      <div v-if="resultado.length != 0" class="content">
        <div class="row">
          <div v-for="item in list" :key="item" class="col-6">
            <a style="width:100%;" :href="item.link" target="_blank">
              <div v-if="item.imagem.length != 0" class="img">
                <img style="align-self: center; max-width: 450px;" :src="item.imagem" alt />
              </div>
              <div v-if="item.imagem.length == 0" class="img-elipse">
                <img
                  style="align-self: center; max-width: 450px;"
                  src="/covid19/img/transferir.png"
                />
              </div>
              <p style="font-size:16px;color:#8b8b8b;text-align:left;">Data: {{ item.data }}</p>
              <p class="resulttitulo">{{ item.titulo }}</p>
              <p
                style="font-size:16px;color:#8b8b8b;text-align:left;"
              >{{ item.descricao.substring() }}</p>
            </a>
          </div>
        </div>
        <div class="paginacao">
          <b-pagination
            v-model="currentPage"
            size="sm"
            :per-page="perpage"
            :total-rows="resultado.length"
            first-text="<"
            prev-text="<<"
            next-text=">"
            last-text=">>"
          ></b-pagination>
          <hr />
        </div>
      </div>
      <div v-else-if="spinner == true" class="spinner flex-centered">
        <b-spinner style="margin: 140px;"></b-spinner>
      </div>
      <div v-else>
        <p
          style="margin: 200px 79px; font-size: 25px; font-weigth: 700;"
          class="flex-centered"
        >Nada encontrado.</p>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
export default {
  data() {
    return {
      titulo: "",
      iconClass: "",
      resultado: [],
      tipo: "",
      estado: 0,
      estados: [],
      categorias: [],
      categoria: "",
      descricao: "",
      spinner: true,
      currentPage: 1,
      perpage: 10
    };
  },
  props: ["view"],
  methods: {
    async buscar() {
      this.resultado = [];
      this.spinner = true;
      if(this.tipo == "Links"){
        this.resultado = await api.getLinks()
      } else {
        this.resultado = await api.getDescEstado(
        this.categoria,
        this.descricao,
        this.estado
      );
      }
      if (this.resultado == undefined) {
        this.resultado = [];
      }
      this.spinner = false;
    },
    checaRota() {
      switch (this.$route.params.select) {
        case "materias":
          this.titulo = "Matérias";
          this.tipo = "Matéria";
          this.iconClass = "far fa-file-alt";
          this.categoria = this.categorias.find(n => n.tipo == this.tipo).id;
          break;
        case "plantoes":
          this.titulo = "Plantões";
          this.tipo = "Plantão";
          this.iconClass = "far fa-bookmark";
          this.categoria = 0;
          this.categoria = this.categorias.find(n => n.tipo == this.tipo).id;
          break;
        case "perguntaserespostas":
          this.titulo = "Perguntas e Respostas";
          this.tipo = "Perguntaserespostas";
          this.iconClass = "far fa-question-circle";
          this.categoria = this.categorias.find(n => n.tipo == this.tipo).id;
          break;
        case "videos":
          this.titulo = "Vídeos";
          this.tipo = "Vídeo";
          this.iconClass = "far fa-file-video";
          this.categoria = this.categorias.find(n => n.tipo == this.tipo).id;
          break;
        case "legislacoes":
          this.titulo = "Legislações";
          this.tipo = "Legislação";
          this.iconClass = "fas fa-book";
          this.categoria = this.categorias.find(n => n.tipo == this.tipo).id;
          break;
        case "links":
          this.titulo = "Links";
          this.tipo = "Links";
          this.iconClass = "fas fa-link";
          this.categoria = this.categorias.find(n => n.tipo == this.tipo).id;
          break;

        default:
          this.titulo = "";
          break;
      }
    }
  },
  async beforeCreate() {
    this.categorias = await api.getCategorias();
    this.estados = await api.getEstados();
    this.checaRota();
    this.buscar();
  },
  created() {
    this.checaRota();
  },
  mounted() {},
  computed: {
    list() {
      return this.resultado.slice(
        (this.currentPage - 1) * this.perpage,
        this.currentPage * this.perpage
      );
    }
  },
  watch: {
    $route(to, from) {
      this.resultado = [];
      this.descricao = "";
      this.estado = 0;
      this.currentPage = 1;
      this.checaRota();
      this.buscar();
    }
  }
};
</script>

<style>
option:first {
  color: #999;
}

li {
  list-style: none;
}
.pagination .page-item {
  border-radius: 10px;
  padding: 5px;
}
.active .page-link:not(:disabled):not(.disabled) {
  background: #444e67;
  color: #fff;
  border: rgb(255, 255, 255);
}
.pagination-sm .page-item:first-child .page-link {
  padding: 8px;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 5px;
  background: #eeeeee;
  color: #616161;
  border: #fff;
}
.page-link:not(:disabled):not(.disabled) {
  cursor: pointer;
  padding: 8px;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 5px;
  background: #eeeeee;
  color: #616161;
  border: #fff;
}
.page-link:not(:disabled):not(.disabled):hover {
  cursor: pointer;
  padding: 8px;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 5px;
  background: #444e67;
  color: #eee;
  border: #eee;
}
.page-item.disabled .page-link {
  padding: 8px;
  padding-left: 9px;
  padding-right: 9px;
  border-radius: 5px;
}

.paginacao {
  display: flex;
  justify-content: flex-end;
  margin-right: 55px;
}

.bordert {
  position: relative;
  top: -7px;
  border-bottom: 1px solid rgb(0, 0, 0, 0.35);
  width: 87%;
}

.view-main {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 50px 15px 75px;
}

.view-main p {
  font-size: 36px;
  font-style: italic;
  color: #383838;
  font-weight: 600;
}

.view-main i {
  margin: 0 15px 0 0;
}

.viewinputs {
  display: flex;
}

.textinputs {
  font-size: 20px;
  margin-left: 150px;
  font-style: italic;
  color: #383838;
  font-weight: 500;
}

input {
  top: -5px;
  left: 10px;
  position: relative;
  outline: none;
  padding-left: 10px;
  width: 370px;
  height: 38px;
  background: 0% 0% no-repeat padding-box padding-box rgb(255, 255, 255);
  border: 1px solid rgb(187, 187, 187);
  border-radius: 5px;
}

select {
  top: -5px;
  left: 10px;
  position: relative;
  outline: none;
  padding-left: 10px;
  width: 370px;
  height: 38px;
  background: 0% 0% no-repeat padding-box padding-box rgb(255, 255, 255);
  border: 1px solid rgb(187, 187, 187);
  border-radius: 5px;
  cursor: pointer;
}

.Select-menu-outer {
  top: auto;
  bottom: 100%;
}

.buscar-btn {
  font-size: 20px;
  font-style: italic;
  font-weight: 500;
  color: #383838;
  position: relative;
  top: -7px;
  left: 45px;
  width: 118px;
  height: 41px;
  border: 1px solid #bbbbbb;
  border-radius: 5px;
}

.buscar-btn:hover {
  color: white;
  background: gray;
}

.voltar-btn {
  font-size: 20px;
  font-style: italic;
  font-weight: 500;
  color: #383838;
  top: -7px;
  right: -875px;
  position: relative;
  width: 118px;
  height: 41px;
  border: 1px solid #bbbbbb;
  border-radius: 5px;
}

.voltar-btn:hover {
  color: white;
  background: gray;
}

.row {
  display: flex;
  justify-content: center;
  align-items: center;
}

.col-6 {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start !important;
  flex-direction: column !important;
  width: 450px;
  max-width: 450px !important;
  height: 350px !important;
  margin: 50px;
  padding: 0 !important;
}

.resulttitulo {
  color: #444e67;
  font-size: 25px;
  font-weight: 700;
  text-align: left;
}

a .img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-elipse {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  clip-path: circle(50% at 50% 50%);
  background: #f9cf64;
}
</style>